import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { InvoiceCurrency } from '@app/core/models/customer.models';
import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';

@Component({
  standalone: false,
  templateUrl: 'pricing-examples-legacy.component.html',
  styleUrls: ['pricing-examples-legacy.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PricingExamplesLegacyComponent {
  readonly currency: InvoiceCurrency;

  constructor(@Inject(NZ_MODAL_DATA) data: { currency: InvoiceCurrency }) {
    this.currency = data.currency;
  }
}
